/* These constants facilitate the cross origin between an iframe and the web SDK */

/**TODO, Find an easier way to share this file between projects. Module Federation maybe?
 * https://github.com/orbaone/web-sdk/blob/master/packages/core/src/elements/constants.ts
 */

export const ORBA_ONE_SUCCESS = "orba_one_success";
export const ORBA_ONE_CANCEL = "orba_one_cancel";
export const ORBA_ONE_MESSAGE_CHANNEL = "message";
